import Make from './Make.vue'
import Model from './Model'
import Trim from './Trim'
import Year from './Year'
import { register } from '~/mixins/pluggable.js'

register('srp', Year)
register('srp', Make)
register('srp', Model)
register('srp', Trim)

export {
  Year,
  Make,
  Model,
  Trim
}
